import React from 'react';
import Alert from 'Components/Alert';
import FieldSet from 'Components/FieldSet';
import PageContent from 'Components/Page/PageContent';
import PageContentBody from 'Components/Page/PageContentBody';
import PageToolbar from 'Components/Page/Toolbar/PageToolbar';
import PageToolbarButton from 'Components/Page/Toolbar/PageToolbarButton';
import PageToolbarSection from 'Components/Page/Toolbar/PageToolbarSection';
import { align, icons, kinds } from 'Helpers/Props';
import { useTdarrServerLog } from '../queries';

export default function Logs() {
  const log = useTdarrServerLog();
  return <PageContent title="Logs">
    <PageToolbar><PageToolbarSection alignContent={align.LEFT}><PageToolbarButton label="Refresh" iconName={icons.REFRESH} isSpinning={log.isFetching} onPress={() => log.refetch()} /></PageToolbarSection></PageToolbar>
    <PageContentBody><FieldSet legend="Server Log">
      {log.isError && <Alert kind={kinds.DANGER}>Unable to load the server log.</Alert>}
      {log.data && <pre className="tdarr-log">{log.data}</pre>}
    </FieldSet></PageContentBody>
  </PageContent>;
}
